<template>

    <section class="banner wrapper" id="banner">
        <div class="banner__logo">
            <img class="banner__img" src="@/assets/img/banner/garlasllc-banner-tittle.svg" alt="Garlas Logo">
        </div>

        <div class="banner__container">
            <div class="banner__container__left">
                <div class="banner__card">
                    <h1 class="banner__heading">{{ $t('banner.title') }}
                    </h1>

                    <div class="banner__card__content">
                        <p class="banner__card__description">
                            {{ $t('banner.description') }}
                        </p>
                        <p class="banner__card__word">{{ $t('banner.word') }}</p>
                    </div>
                </div>
            </div>
            <div class="banner__container__right">
                <div class="banner__img__container">
                    <a href="https://www.nomanejes.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 18%">
                        <img width="100%" src="@/assets/img/banner/logo_nomanejes.svg" alt="No Manejes Logo">
                    </a>
                    <a href="https://www.puertoricocartransfer.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 20%">
                        <img width="100%" src="@/assets/img/banner/logo_puertoricocartransfer.svg"
                            alt="Puerto Rico Car Transfer Logo">
                    </a>
                    <a href="https://www.carrosacentroamerica.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 14%">
                        <img width="100%" src="@/assets/img/banner/logo_carrosacentroamerica.svg"
                            alt="Carros A Centro America Logo">
                    </a>
                    <a href="https://www.prautotransport.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 12%">
                        <img width="100%" src="@/assets/img/banner/logo_prautotransport.svg" alt="Pr Auto Transport Logo">
                    </a>
                    <a href="https://www.carmoversus.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 10%">
                        <img width="100%" src="@/assets/img/banner/logo_carmoversus.svg" alt="Car Movers Us Logo">
                    </a>
                </div>
                <div class="banner__img__container">
                    <a href="https://www.shipshippersusa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 34%">
                        <img width="100%" src="@/assets/img/banner/logo_shipshippersusa.svg" alt="Ship Shippers Usa Logo">
                    </a>
                    <a href="https://www.ratesautotransport.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 22%">
                        <img width="100%" src="@/assets/img/banner/logo_ratesautotransport.svg"
                            alt=" Rates Auto Transport Logo">
                    </a>
                    <a href="https://www.tucarroporusa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 12%">
                        <img width="100%" src="@/assets/img/banner/logo_tucarroporusa.svg" alt="Tu Carro Por USA Logo">
                    </a>
                    <a href="https://www.tucarroporamerica.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 20%">
                        <img width="100%" src="@/assets/img/banner/logo_tcpamerica.svg" alt="Tcp America Logo">
                    </a>
                </div>
                <!-- Ally Logos -->
                <div class="banner__img__container">
                    <a href="https://www.centraldispatch.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 32%">
                        <img width="100%" src="@/assets/img/banner/logo_ally_centraldispatch.svg"
                            alt="Central Dispatch Logo">
                    </a>
                    <a href="https://www.seaboardmarine.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 20%">
                        <img width="100%" src="@/assets/img/banner/logo_ally_seaboardmarine.svg" alt="Seaboard Marine Logo">
                    </a>
                    <a href="https://www.trailerbridge.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 26%">
                        <img width="100%" src="@/assets/img/banner/logo_ally_trailerbridge.svg" alt="Trailer Bridge Logo">
                    </a>
                </div>

                <div class="banner__img__container">
                    <a href="https://www.crowley.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 26%">
                        <img width="100%" src="@/assets/img/banner/logo_ally_crowley.svg" alt="Crowley Logo">
                    </a>
                    <a href="https://interporthouston.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 16%">
                        <img width="100%" src="@/assets/img/banner/logo_ally_interport.svg" alt="Interport Logo">
                    </a>
                    <a href="https://www.cmacgm-group.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" style="width: 20%">
                        <img width="100%" src="@/assets/img/banner/logo_ally_cmacgm.svg" alt="CMACGM Logo">
                    </a>
                </div>

                <!-- payments -->
                <div class="banner__img__container">
                    <div class="banner__img__payments">
                        <a href="https://www.visa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img height="28px" src="@/assets/img/banner/logo_payment_visa.svg" alt="Visa Logo">
                        </a>
                        <a href="https://www.mastercard.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img height="38px" src="@/assets/img/banner/logo_payment_mastercard.svg" alt="Mastercard Logo">
                        </a>
                        <a href="https://www.americanexpress.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img height="28px" src="@/assets/img/banner/logo_payment_americanexpress.svg"
                                alt="American Express Logo">
                        </a>
                    </div>
                    <div class="banner__payments__description">
                        <p>{{ $t('banner.payment_span') }}</p>
                    </div>
                </div>
            </div>
            <div class="banner__container__slider">
                <div class="logo__slider">
                    <div class="logo__slider__track">
                        <a href="https://www.nomanejes.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_nomanejes.svg"
                                alt="No Manejes Logo">
                        </a>
                        <a href="https://www.puertoricocartransfer.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_puertoricocartransfer.svg"
                                alt="Puerto Rico Car Transfer Logo">
                        </a>
                        <a href="https://www.carrosacentroamerica.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_carrosacentroamerica.svg"
                                alt="Carros A Centro America Logo">
                        </a>
                        <a href="https://www.prautotransport.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_prautotransport.svg"
                                alt="Pr Auto Transport Logo">
                        </a>
                        <a href="https://www.carmoversus.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_carmoversus.svg"
                                alt="Car Movers Us Logo">
                        </a>
                        <a href="https://www.shipshippersusa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_shipshippersusa.svg"
                                alt="Ship Shippers Usa Logo">
                        </a>
                        <a href="https://www.ratesautotransport.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ratesautotransport.svg"
                                alt=" Rates Auto Transport Logo">
                        </a>
                        <a href="https://www.tucarroporusa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_tucarroporusa.svg"
                                alt="Tu Carro Por USA Logo">
                        </a>
                        <a href="https://www.tucarroporamerica.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_tcpamerica.svg"
                                alt="Tcp America Logo">
                        </a>
                        <a href="https://www.nomanejes.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_nomanejes.svg"
                                alt="No Manejes Logo">
                        </a>
                        <a href="https://www.puertoricocartransfer.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_puertoricocartransfer.svg"
                                alt="Puerto Rico Car Transfer Logo">
                        </a>
                        <a href="https://www.carrosacentroamerica.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_carrosacentroamerica.svg"
                                alt="Carros A Centro America Logo">
                        </a>
                        <a href="https://www.prautotransport.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_prautotransport.svg"
                                alt="Pr Auto Transport Logo">
                        </a>
                        <a href="https://www.carmoversus.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_carmoversus.svg"
                                alt="Car Movers Us Logo">
                        </a>
                        <a href="https://www.shipshippersusa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_shipshippersusa.svg"
                                alt="Ship Shippers Usa Logo">
                        </a>
                        <a href="https://www.ratesautotransport.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ratesautotransport.svg"
                                alt=" Rates Auto Transport Logo">
                        </a>
                        <a href="https://www.tucarroporusa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_tucarroporusa.svg"
                                alt="Tu Carro Por USA Logo">
                        </a>
                        <a href="https://www.tucarroporamerica.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_tcpamerica.svg"
                                alt="Tcp America Logo">
                        </a>
                    </div>
                </div>
                <div class="logo__slider">
                    <div class="logo__slider__track">
                        <a href="https://www.centraldispatch.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_centraldispatch.svg"
                                alt="Central Dispatch Logo">
                        </a>
                        <a href="https://www.seaboardmarine.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_seaboardmarine.svg"
                                alt="Seaboard Marine Logo">
                        </a>
                        <a href="https://www.trailerbridge.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_trailerbridge.svg"
                                alt="Trailer Bridge Logo">
                        </a>
                        <a href="https://www.crowley.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_crowley.svg"
                                alt="Crowley Logo">
                        </a>
                        <a href="https://interporthouston.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_interport.svg"
                                alt="Interport Logo">
                        </a>
                        <a href="https://www.cmacgm-group.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_cmacgm.svg" alt="CMACGM Logo">
                        </a>
                        <a href="https://www.centraldispatch.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_centraldispatch.svg"
                                alt="Central Dispatch Logo">
                        </a>
                        <a href="https://www.seaboardmarine.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_seaboardmarine.svg"
                                alt="Seaboard Marine Logo">
                        </a>
                        <a href="https://www.trailerbridge.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_trailerbridge.svg"
                                alt="Trailer Bridge Logo">
                        </a>
                        <a href="https://www.crowley.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_crowley.svg"
                                alt="Crowley Logo">
                        </a>
                        <a href="https://interporthouston.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_interport.svg"
                                alt="Interport Logo">
                        </a>
                        <a href="https://www.cmacgm-group.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link" aria-hidden="true" tabindex="-1">
                            <img class="logo__slider__img" src="@/assets/img/banner/logo_ally_cmacgm.svg" alt="CMACGM Logo">
                        </a>
                    </div>
                </div>
                <div class="logo__slider__payment">
                    <a href="https://www.visa.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                        <img height="28px" src="@/assets/img/banner/logo_payment_visa.svg" alt="Visa Logo">
                    </a>
                    <a href="https://www.mastercard.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                        <img height="38px" src="@/assets/img/banner/logo_payment_mastercard.svg" alt="Mastercard Logo">
                    </a>
                    <a href="https://www.americanexpress.com" target="_blank" rel="noopener noreferrer" class="banner-logo-link">
                        <img height="28px" src="@/assets/img/banner/logo_payment_americanexpress.svg"
                            alt="American Express Logo">
                    </a>
                </div>
                <div class="logo__slider__description">
                    <p>{{ $t('banner.payment_span') }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.banner {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    height: 100%;
    padding-block: 6rem !important;
}

.banner__container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    gap: 6rem;
}

.banner__container__left,
.banner__container__right {
    display: flex;
    flex-direction: column;
    width: 50%;
    min-height: 100%;
}

.banner__container__right {
    align-content: center;
    gap: 2rem;
}

.banner__heading {
    font-size: 2.5rem;
    line-height: 3rem;
    font-weight: 600;
    color: var(--SecondaryColor);
}

.banner__card {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.banner__card__content {
    height: 100%;
    background-color: var(--PrimaryColor);
    padding: 2rem;
    border-radius: 25px;
    color: var(--SecondaryColor);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.banner__card__description {
    font-size: 2rem;
    line-height: 2.5rem;
    font-weight: 400;
    margin-bottom: 1rem;
}

.banner__card__word {
    font-size: 2.5rem;
    line-height: 3rem;
    font-weight: 600;
    place-self: end;
}

.banner__img__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.banner__img__payments {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.banner__logo {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
}

.banner__img {
    max-width: fit-content;
    margin: 0;
    width: auto;
    height: 40px;
}

.banner__payments__description {
    padding-left: 1rem;
    text-align: center;
    font-size: 1.5rem;
    text-wrap: normal;
    line-height: 2rem;
    font-weight: 400;
    color: var(--SecondaryColor);
}

@media only screen and (min-width: 770px) {
    .banner__container__slider {
        display: none !important;
    }
}


@media only screen and (max-width: 770px) {
    .banner__container {
        flex-direction: column;
        gap: 2rem;
    }

    .banner__container__left {
        width: 100%;
    }

    .banner__container__right {
        display: none;
    }
}

.banner__container__slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    width: 100%;
    padding-block: 2rem;
}

.logo__slider {
    position: relative;
    overflow: hidden;
    display: inline-block;
    margin-block: 1rem;
    mask-image: linear-gradient(to right, transparent 0, white 10px, white calc(100% - 10px), transparent 100%);
    width: 100%;
}

.logo__slider__track {
    animation: slide-left 15s linear infinite;
    white-space: nowrap;
    display: inline-flex;
}

.logo__slider:hover .logo__slider__track {
    animation-play-state: paused;
}

@keyframes slide-left {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

.logo__slider__img {
    margin-inline: 1rem;
    height: 35px;
    flex-shrink: 0;
}

.logo__slider__payment {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2.5rem;
}

.logo__slider__description {
    text-align: center;
    font-size: 2.6rem;
    line-height: 3rem;
    letter-spacing: 5%;
    font-weight: 500;
    color: var(--SecondaryColor);
}

/* Logos del banner Garlas LLC: enlaces con animación sutil al pasar el cursor */
.banner-logo-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 200ms ease-out, opacity 200ms ease-out;
}

.banner-logo-link:hover,
.banner-logo-link:focus-visible {
    transform: translateY(-2px) scale(1.05);
    opacity: 0.85;
}

@media (prefers-reduced-motion: reduce) {
    .banner-logo-link:hover,
    .banner-logo-link:focus-visible {
        transform: none;
    }
}

/* Espacio para que la animación de los logos no se recorte en el slider */
.logo__slider {
    padding-block: 4px;
}
</style>